
import { Helmet } from 'react-helmet-async';

interface LocalBusinessSchemaProps {
  localBusiness: {
    city?: string;
    region?: string;
    postalCode?: string;
    serviceType?: string;
  };
  title: string;
  description: string;
  canonical: string;
  ogImage: string;
}

const LocalBusinessSchema = ({
  localBusiness,
  title,
  description,
  canonical,
  ogImage
}: LocalBusinessSchemaProps) => {
  const { city, region, postalCode, serviceType } = localBusiness;
  const serviceArea = city || region || postalCode;
  
  if (!serviceArea || !serviceType) {
    return null;
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": `Groupe Fabre Environnement - ${serviceType} ${serviceArea}`,
    "description": `Services de ${serviceType.toLowerCase()} professionnels à ${serviceArea}. ${description}`,
    "url": canonical,
    "logo": {
      "@type": "ImageObject",
      "url": ogImage,
      "width": 1200,
      "height": 630
    },
    "image": [
      {
        "@type": "ImageObject",
        "url": ogImage,
        "width": 1200,
        "height": 630
      }
    ],
    "telephone": "+33565787900",
    "email": "contactgfe@groupefabre.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": city || "Rodez",
      "addressRegion": region || "Occitanie",
      "postalCode": postalCode || "12000",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "44.3500",
      "longitude": "2.5833"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "17:00"
      }
    ],
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "44.3500",
        "longitude": "2.5833"
      },
      "geoRadius": "100000"
    },
    "priceRange": "€€",
    "paymentAccepted": ["Cash", "Credit Card", "Invoice"],
    "currenciesAccepted": "EUR"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
